/**
 * Is deze afspraak afgevinkt?
 *
 * Booleans worden in deze app op twee manieren weggeschreven: als echte
 * boolean en als de tekst 'true' (ToggleButton). Een vergelijking op één van
 * beide vormen laat de helft van de gevallen stil door.
 * AI-CONTEXT: See docs/pitfalls.md#database-string-enum-boolean-coercion
 *
 * @param {{Done?: boolean|string}|null|undefined} task
 * @returns {boolean}
 */
const isTaskDone = (task) => task?.Done === true || task?.Done === 'true'

export default isTaskDone
